import React from "react";
import { SiAmazon, SiFlipkart, SiShopify } from "react-icons/si";

const wrap = (node) => (
  <span style={{ flexShrink: 0, display: "inline-flex", lineHeight: 0 }} aria-hidden>
    {node}
  </span>
);

/**
 * Bundled marketplace marks (no external CDN) so CSP / offline dev still show logos.
 * Myntra / Meesho / Snapdeal: simplified inline SVGs using brand colors (placeholders, not official marks).
 */
export default function MarketplacePlatformIcon({ platformKey, size = 20 }) {
  const s = Number(size) || 20;

  switch (platformKey) {
    case "amazon":
      return wrap(<SiAmazon size={s} color="#FF9900" />);
    case "flipkart":
      return wrap(<SiFlipkart size={s} color="#2874F0" />);
    case "shopify":
      return wrap(<SiShopify size={s} color="#96BF48" />);
    case "myntra":
      return wrap(
        <svg width={s} height={s} viewBox="0 0 24 24" aria-hidden>
          <rect width="24" height="24" rx="5" fill="#FF3F6C" />
          <path
            fill="#fff"
            d="M6.5 17V7.2h2.8l2.2 5.4 2.2-5.4h2.7V17h-2.3v-5.2L12 16.2h-.1L8.8 11.8V17H6.5z"
          />
        </svg>
      );
    case "meesho":
      return wrap(
        <svg width={s} height={s} viewBox="0 0 24 24" aria-hidden>
          <rect width="24" height="24" rx="5" fill="#F43397" />
          <path
            fill="#fff"
            d="M7 7.5h2.2c2 0 3.2 1.1 3.2 2.9 0 1.8-1.2 2.9-3.2 2.9H9.2V17H7V7.5zm2.1 4.3c.9 0 1.4-.5 1.4-1.3s-.5-1.3-1.4-1.3H9.2v2.6h-.1zM14.3 7.5H17v9h-2.7v-9z"
          />
        </svg>
      );
    case "snapdeal":
      return wrap(
        <svg width={s} height={s} viewBox="0 0 24 24" aria-hidden>
          <rect width="24" height="24" rx="5" fill="#E31E24" />
          <path
            fill="#fff"
            d="M7.2 12c0-2.4 1.8-4.2 4.3-4.2 1.2 0 2.2.4 3 1.1l-1.3 1.5c-.5-.4-1.1-.7-1.7-.7-1.2 0-2.1 1-2.1 2.3s.9 2.3 2.1 2.3c.8 0 1.4-.3 1.9-.8l1.3 1.4c-.8.8-1.9 1.3-3.2 1.3-2.5 0-4.3-1.8-4.3-4.2z"
          />
        </svg>
      );
    default:
      return null;
  }
}
